import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupColumnKey } from "@redotech/redo-fulfillment-common/fulfillment-group-column-keys";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { WeightFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { ViewColumn } from "@redotech/redo-views-common/views";
import { AddressVerificationCsvColumn } from "./address-verification-csv";
import { AssignedTotesCsvColumn } from "./assigned-totes-csv";
import { AssignedUserCsvColumn } from "./assigned-user-csv";
import { BatchIdCsvColumn } from "./batch-id-csv";
import { BinCsvColumn } from "./bin-csv";
import { CommercialInvoiceSubmittedElectronicallyCsvColumn } from "./commercial-invoice-csv";
import { getCustomDateCsvColumn } from "./custom-date-csv";
import { getCustomNumberCsvColumn } from "./custom-number-csv";
import { getCustomStringCsvColumn } from "./custom-string-csv";
import { CustomerEmailCsvColumn } from "./customer-email-csv";
import { CustomerIdCsvColumn } from "./customer-id-csv";
import { CustomerNameCsvColumn } from "./customer-name-csv";
import { CustomerOrderCountCsvColumn } from "./customer-order-count-csv";
import { CustomerPhoneCsvColumn } from "./customer-phone-csv";
import { CustomerPoNumberCsvColumn } from "./customer-po-number-csv";
import { CustomerShippingSelectionCsvColumn } from "./customer-shipping-selection-csv";
import { DeliveryDateCsvColumn } from "./delivery-date-csv";
import { DeliveryMethodCsvColumn } from "./delivery-method-csv";
import { DeliveryStatusCsvColumn } from "./delivery-status-csv";
import { DestinationCountryCsvColumn } from "./destination-country-csv";
import { EstimatedDeliveryDateCsvColumn } from "./estimated-delivery-date-csv";
import { FraudRiskCsvColumn } from "./fraud-risk-csv";
import { FulfilledByCsvColumn } from "./fulfilled-by-csv";
import { FulfillmentLocationCsvColumn } from "./fulfillment-location-csv";
import { HoldNotesCsvColumn } from "./hold-notes-csv";
import { InternalNotesCsvColumn } from "./internal-notes-csv";
import { ItemBarcodeCsvColumn } from "./item-barcode-csv";
import { ItemNameCsvColumn } from "./item-name-csv";
import { ItemSKUCsvColumn } from "./item-sku-csv";
import { LabelPurchasedAtCsvColumn } from "./label-purchased-at-csv";
import { LineItemCustomAttributesCsvColumn } from "./line-item-custom-attributes-csv";
import { LotExpirationDateCsvColumn } from "./lot-expiration-date-csv";
import { LotNumberCsvColumn } from "./lot-number-csv";
import { MarketplaceFulfillByCsvColumn } from "./marketplace-fulfill-by-csv";
import { MarketplaceInternalNoteCsvColumn } from "./marketplace-internal-note-csv";
import { MissingBinsCsvColumn } from "./missing-bins-csv";
import { NoteFromBuyerCsvColumn } from "./note-from-buyer-csv";
import { NoteToBuyerCsvColumn } from "./note-to-buyer-csv";
import { NumberOfLineItemsCsvColumn } from "./number-of-line-items-csv";
import { OrderAgeCsvColumn } from "./order-age-csv";
import { OrderDateCsvColumn } from "./order-date-csv";
import { OrderItemsCsvColumn } from "./order-items-csv";
import { OrderNameCsvColumn } from "./order-name-csv";
import { OrderSourceCsvColumn } from "./order-source-csv";
import { OrderSubtotalCsvColumn } from "./order-subtotal-csv";
import { OrderTotalCsvColumn } from "./order-total-csv";
import { getOrderWeightCsvColumn } from "./order-weight-csv";
import { OriginStoreCsvColumn } from "./origin-store-csv";
import { PackingSlipPrintedAtCsvColumn } from "./packing-slip-printed-at-csv";
import { ParcelSelectionCsvColumn } from "./parcel-selection-csv";
import { PaymentTypeCsvColumn } from "./payment-type-csv";
import { PickStatusCsvColumn } from "./pick-status-csv";
import { getPostalCodeColumnCsvColumn } from "./postal-code-csv";
import { getProductCustomDateCsvColumn } from "./product-custom-date-csv";
import { getProductCustomNumberCsvColumn } from "./product-custom-number-csv";
import { getProductCustomStringCsvColumn } from "./product-custom-string-csv";
import { ProductTagsCsvColumn } from "./product-tags-csv";
import { ProductVariantCsvColumn } from "./product-variant-csv";
import { RateCsvColumn } from "./rate-csv";
import { RecipientNameCsvColumn } from "./recipient-name-csv";
import { RequestedServiceCsvColumn } from "./requested-service-csv";
import { SalesChannelCsvColumn } from "./sales-channel-csv";
import { SerialNumberCsvColumn } from "./serial-number-csv";
import { ShipmentCreatedAtCsvColumn } from "./shipment-created-at-csv";
import { ShipmentTagsCsvColumn } from "./shipment-tags-csv";
import { ShippedDateCsvColumn } from "./shipped-date-csv";
import { ShippingInsuranceCsvColumn } from "./shipping-insurance-csv";
import { ShippingMarginCsvColumn } from "./shipping-margin-csv";
import { ShippingPaidCsvColumn } from "./shipping-paid-csv";
import { ShippingSelectionCsvColumn } from "./shipping-selection-csv";
import { ShopifyOrderTagsCsvColumn } from "./shopify-order-tags-csv";
import { SLADeliveryPromiseCsvColumn } from "./sla-delivery-promise-csv";
import { StateCsvColumn } from "./state-csv";
import { StatusCsvColumn } from "./status-csv";
import { StreetAddressCsvColumn } from "./street-address-csv";
import { TaxTotalCsvColumn } from "./tax-total-csv";
import { TrackingNumberCsvColumn } from "./tracking-number-csv";
import { TotalCostCsvColumn, UnitCostCsvColumn } from "./unit-cost-csv";
import { UsedParcelLearningCsvColumn } from "./used-parcel-learning-csv";
import { UsedWeightLearningCsvColumn } from "./used-weight-learning-csv";
import { USPSZoneCsvColumn } from "./usps-zone-csv";
import { getVariantCustomDateCsvColumn } from "./variant-custom-date-csv";
import { getVariantCustomNumberCsvColumn } from "./variant-custom-number-csv";
import { getVariantCustomStringCsvColumn } from "./variant-custom-string-csv";
import { VendorsCsvColumn } from "./vendors-csv";

export interface CustomMetadataSetting {
  key: string;
  namespace: string;
  displayName?: string;
}

export interface TeamCustomSettings {
  customDate1?: CustomMetadataSetting;
  customDate2?: CustomMetadataSetting;
  customDate3?: CustomMetadataSetting;
  customString1?: CustomMetadataSetting;
  customString2?: CustomMetadataSetting;
  customString3?: CustomMetadataSetting;
  customNumber1?: CustomMetadataSetting;
  customNumber2?: CustomMetadataSetting;
  customNumber3?: CustomMetadataSetting;
}

export interface TeamCustomAttributeSettings {
  customAttributeDate1?: { key: string; displayName?: string };
  customAttributeDate2?: { key: string; displayName?: string };
  customAttributeDate3?: { key: string; displayName?: string };
  customAttributeString1?: { key: string; displayName?: string };
  customAttributeString2?: { key: string; displayName?: string };
  customAttributeString3?: { key: string; displayName?: string };
  customAttributeNumber1?: { key: string; displayName?: string };
  customAttributeNumber2?: { key: string; displayName?: string };
  customAttributeNumber3?: { key: string; displayName?: string };
}

export interface ProductCustomMetadataSettings {
  productCustomDate1?: CustomMetadataSetting;
  productCustomDate2?: CustomMetadataSetting;
  productCustomDate3?: CustomMetadataSetting;
  productCustomString1?: CustomMetadataSetting;
  productCustomString2?: CustomMetadataSetting;
  productCustomString3?: CustomMetadataSetting;
  productCustomNumber1?: CustomMetadataSetting;
  productCustomNumber2?: CustomMetadataSetting;
  productCustomNumber3?: CustomMetadataSetting;
}

export interface VariantCustomMetadataSettings {
  variantCustomDate1?: CustomMetadataSetting;
  variantCustomDate2?: CustomMetadataSetting;
  variantCustomDate3?: CustomMetadataSetting;
  variantCustomString1?: CustomMetadataSetting;
  variantCustomString2?: CustomMetadataSetting;
  variantCustomString3?: CustomMetadataSetting;
  variantCustomNumber1?: CustomMetadataSetting;
  variantCustomNumber2?: CustomMetadataSetting;
  variantCustomNumber3?: CustomMetadataSetting;
}

export interface DisplayedColumn {
  key: string;
  displayed: boolean;
}

export function getAllCsvColumns({
  autoCleanAddresses,
  weightFormat,
}: {
  autoCleanAddresses: boolean;
  weightFormat: WeightFormat;
}): Partial<
  Record<
    FulfillmentGroupColumnKey,
    FulfillmentGroupCsvColumn<FulfillmentGroupData>
  >
> &
  Record<string, FulfillmentGroupCsvColumn<FulfillmentGroupData>> {
  return {
    [FulfillmentGroupColumnKey.ASSIGNED_USER]: AssignedUserCsvColumn,
    [FulfillmentGroupColumnKey.CUSTOMER]: CustomerNameCsvColumn,
    [FulfillmentGroupColumnKey.CUSTOMER_EMAIL]: CustomerEmailCsvColumn,
    [FulfillmentGroupColumnKey.CUSTOMER_PHONE]: CustomerPhoneCsvColumn,
    [FulfillmentGroupColumnKey.CUSTOMER_ID]: CustomerIdCsvColumn,
    [FulfillmentGroupColumnKey.CUSTOMER_SHIPPING_SELECTION]:
      CustomerShippingSelectionCsvColumn,
    [FulfillmentGroupColumnKey.DELIVERY_METHOD]: DeliveryMethodCsvColumn,
    [FulfillmentGroupColumnKey.DESTINATION_COUNTRY]:
      DestinationCountryCsvColumn,
    [FulfillmentGroupColumnKey.FRAUD_RISK]: FraudRiskCsvColumn,
    [FulfillmentGroupColumnKey.FULFILLMENT_LOCATION]:
      FulfillmentLocationCsvColumn,
    [FulfillmentGroupColumnKey.ITEM_NAME]: ItemNameCsvColumn,
    [FulfillmentGroupColumnKey.ITEM_SKU]: ItemSKUCsvColumn,
    [FulfillmentGroupColumnKey.ITEM_BARCODE]: ItemBarcodeCsvColumn,
    [FulfillmentGroupColumnKey.LINE_ITEM_CUSTOM_ATTRIBUTES]:
      LineItemCustomAttributesCsvColumn,
    [FulfillmentGroupColumnKey.ORDER_AGE]: OrderAgeCsvColumn,
    [FulfillmentGroupColumnKey.ORDER_DATE]: OrderDateCsvColumn,
    [FulfillmentGroupColumnKey.QUANTITY]: OrderItemsCsvColumn,
    [FulfillmentGroupColumnKey.ORDER_NAME]: OrderNameCsvColumn,
    [FulfillmentGroupColumnKey.ORDER_SOURCE]: OrderSourceCsvColumn,
    [FulfillmentGroupColumnKey.TOTAL]: OrderTotalCsvColumn,
    [FulfillmentGroupColumnKey.ORDER_SUBTOTAL]: OrderSubtotalCsvColumn,
    [FulfillmentGroupColumnKey.TAX_TOTAL]: TaxTotalCsvColumn,
    [FulfillmentGroupColumnKey.WEIGHT]: getOrderWeightCsvColumn(weightFormat),
    [FulfillmentGroupColumnKey.PRODUCT_VARIANT]: ProductVariantCsvColumn,
    [FulfillmentGroupColumnKey.RATE]: RateCsvColumn,
    [FulfillmentGroupColumnKey.REQUESTED_SERVICE]: RequestedServiceCsvColumn,
    [FulfillmentGroupColumnKey.PARCEL_SELECTION]: ParcelSelectionCsvColumn,
    [FulfillmentGroupColumnKey.SHIPMENT_CREATED_AT]: ShipmentCreatedAtCsvColumn,
    [FulfillmentGroupColumnKey.SHIPPED_DATE]: ShippedDateCsvColumn,
    [FulfillmentGroupColumnKey.SHIPPING_MARGIN]: ShippingMarginCsvColumn,
    [FulfillmentGroupColumnKey.SHIPPING_PAID]: ShippingPaidCsvColumn,
    [FulfillmentGroupColumnKey.SHIPPING_SELECTION]: ShippingSelectionCsvColumn,
    [FulfillmentGroupColumnKey.SHOPIFY_ORDER_TAGS]: ShopifyOrderTagsCsvColumn,
    [FulfillmentGroupColumnKey.PRODUCT_TAGS]: ProductTagsCsvColumn,
    [FulfillmentGroupColumnKey.VENDORS]: VendorsCsvColumn,
    [FulfillmentGroupColumnKey.STATE]: StateCsvColumn,
    [FulfillmentGroupColumnKey.STATUS]: StatusCsvColumn,
    [FulfillmentGroupColumnKey.PICK_STATUS]: PickStatusCsvColumn,
    [FulfillmentGroupColumnKey.ASSIGNED_TOTES]: AssignedTotesCsvColumn,
    [FulfillmentGroupColumnKey.TRACKING_NUMBER]: TrackingNumberCsvColumn,
    [FulfillmentGroupColumnKey.TOTAL_SKU_COUNT]: NumberOfLineItemsCsvColumn,
    [FulfillmentGroupColumnKey.POSTAL_CODE]:
      getPostalCodeColumnCsvColumn(autoCleanAddresses),
    [FulfillmentGroupColumnKey.INSURED]: ShippingInsuranceCsvColumn,
    [FulfillmentGroupColumnKey.FULFILLED_BY]: FulfilledByCsvColumn,
    [FulfillmentGroupColumnKey.FULFILL_BY]: MarketplaceFulfillByCsvColumn,
    [FulfillmentGroupColumnKey.LABEL_PURCHASED_AT]: LabelPurchasedAtCsvColumn,
    [FulfillmentGroupColumnKey.ELECTRONIC_COM_INVOICE]:
      CommercialInvoiceSubmittedElectronicallyCsvColumn,
    [FulfillmentGroupColumnKey.USPS_ZONE]: USPSZoneCsvColumn,
    [FulfillmentGroupColumnKey.BIN]: BinCsvColumn,
    [FulfillmentGroupColumnKey.BATCH_ID]: BatchIdCsvColumn,
    [FulfillmentGroupColumnKey.SALES_CHANNEL]: SalesChannelCsvColumn,
    [FulfillmentGroupColumnKey.SERIAL_NUMBER]: SerialNumberCsvColumn,
    [FulfillmentGroupColumnKey.LOT_NUMBER]: LotNumberCsvColumn,
    [FulfillmentGroupColumnKey.LOT_EXPIRATION_DATE]: LotExpirationDateCsvColumn,
    [FulfillmentGroupColumnKey.UNIT_COST]: UnitCostCsvColumn,
    [FulfillmentGroupColumnKey.TOTAL_COST]: TotalCostCsvColumn,
    [FulfillmentGroupColumnKey.DELIVERY_STATUS]: DeliveryStatusCsvColumn,
    [FulfillmentGroupColumnKey.DELIVERY_DATE]: DeliveryDateCsvColumn,
    [FulfillmentGroupColumnKey.ESTIMATED_DELIVERY_DATE]:
      EstimatedDeliveryDateCsvColumn,
    [FulfillmentGroupColumnKey.PACKING_SLIP_PRINTED_AT]:
      PackingSlipPrintedAtCsvColumn,
    [FulfillmentGroupColumnKey.SLA_DELIVERY_PROMISE]:
      SLADeliveryPromiseCsvColumn,
    [FulfillmentGroupColumnKey.MISSING_BINS]: MissingBinsCsvColumn,
    [FulfillmentGroupColumnKey.RECIPIENT]: RecipientNameCsvColumn,
    [FulfillmentGroupColumnKey.STREET_ADDRESS]: StreetAddressCsvColumn,
    [FulfillmentGroupColumnKey.CUSTOMER_ORDER_COUNT]:
      CustomerOrderCountCsvColumn,
    [FulfillmentGroupColumnKey.PAYMENT_TYPE]: PaymentTypeCsvColumn,
    [FulfillmentGroupColumnKey.HOLD_NOTES]: HoldNotesCsvColumn,
    [FulfillmentGroupColumnKey.INTERNAL_NOTES]: InternalNotesCsvColumn,
    [FulfillmentGroupColumnKey.NOTE_FROM_BUYER]: NoteFromBuyerCsvColumn,
    [FulfillmentGroupColumnKey.NOTE_TO_BUYER]: NoteToBuyerCsvColumn,
    [FulfillmentGroupColumnKey.MARKETPLACE_INTERNAL_NOTE]:
      MarketplaceInternalNoteCsvColumn,
    [FulfillmentGroupColumnKey.CUSTOMER_PO]: CustomerPoNumberCsvColumn,
    [FulfillmentGroupColumnKey.ORIGIN_STORE]: OriginStoreCsvColumn,
    [FulfillmentGroupColumnKey.ADDRESS_VERIFICATION]:
      AddressVerificationCsvColumn,
    [FulfillmentGroupColumnKey.SHIPMENT_TAGS]: ShipmentTagsCsvColumn,
    [FulfillmentGroupColumnKey.USED_WEIGHT_LEARNING]:
      UsedWeightLearningCsvColumn,
    [FulfillmentGroupColumnKey.USED_PARCEL_LEARNING]:
      UsedParcelLearningCsvColumn,
  };
}

export function getFulfillmentOrderCsv({
  autoCleanAddresses,
  weightFormat,
  columns,
  displayedColumns,
  customMetadataSettings,
  customAttributesSettings,
  productCustomMetadataSettings,
  variantCustomMetadataSettings,
  wmsEnabled,
}: {
  autoCleanAddresses: boolean;
  weightFormat: string;
  columns: ViewColumn[];
  displayedColumns: DisplayedColumn[];
  customMetadataSettings?: TeamCustomSettings;
  customAttributesSettings?: TeamCustomAttributeSettings;
  productCustomMetadataSettings?: ProductCustomMetadataSettings;
  variantCustomMetadataSettings?: VariantCustomMetadataSettings;
  wmsEnabled: boolean;
}): FulfillmentGroupCsvColumn<FulfillmentGroupData>[] {
  const selected_columns: FulfillmentGroupCsvColumn<FulfillmentGroupData>[] =
    [];

  const allCsvColumns = getAllCsvColumns({
    autoCleanAddresses,
    weightFormat: weightFormat as WeightFormat,
  });

  if (!wmsEnabled) {
    delete allCsvColumns[FulfillmentGroupColumnKey.PICK_STATUS];
    delete allCsvColumns[FulfillmentGroupColumnKey.ASSIGNED_TOTES];
    delete allCsvColumns[FulfillmentGroupColumnKey.LOT_NUMBER];
    delete allCsvColumns[FulfillmentGroupColumnKey.LOT_EXPIRATION_DATE];
  }

  // Add dynamic custom metadata columns
  if (customMetadataSettings) {
    if (customMetadataSettings.customDate1) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_DATE_1] =
        getCustomDateCsvColumn(
          customMetadataSettings.customDate1.displayName ??
            `${customMetadataSettings.customDate1.key}.${customMetadataSettings.customDate1.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_DATE_1,
        );
    }
    if (customMetadataSettings.customDate2) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_DATE_2] =
        getCustomDateCsvColumn(
          customMetadataSettings.customDate2.displayName ??
            `${customMetadataSettings.customDate2.key}.${customMetadataSettings.customDate2.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_DATE_2,
        );
    }
    if (customMetadataSettings.customDate3) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_DATE_3] =
        getCustomDateCsvColumn(
          customMetadataSettings.customDate3.displayName ??
            `${customMetadataSettings.customDate3.key}.${customMetadataSettings.customDate3.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_DATE_3,
        );
    }
    if (customMetadataSettings.customString1) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_STRING_1] =
        getCustomStringCsvColumn(
          customMetadataSettings.customString1.displayName ??
            `${customMetadataSettings.customString1.key}.${customMetadataSettings.customString1.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_STRING_1,
        );
    }
    if (customMetadataSettings.customString2) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_STRING_2] =
        getCustomStringCsvColumn(
          customMetadataSettings.customString2.displayName ??
            `${customMetadataSettings.customString2.key}.${customMetadataSettings.customString2.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_STRING_2,
        );
    }
    if (customMetadataSettings.customString3) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_STRING_3] =
        getCustomStringCsvColumn(
          customMetadataSettings.customString3.displayName ??
            `${customMetadataSettings.customString3.key}.${customMetadataSettings.customString3.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_STRING_3,
        );
    }
    if (customMetadataSettings.customNumber1) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_NUMBER_1] =
        getCustomNumberCsvColumn(
          customMetadataSettings.customNumber1.displayName ??
            `${customMetadataSettings.customNumber1.key}.${customMetadataSettings.customNumber1.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_NUMBER_1,
        );
    }
    if (customMetadataSettings.customNumber2) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_NUMBER_2] =
        getCustomNumberCsvColumn(
          customMetadataSettings.customNumber2.displayName ??
            `${customMetadataSettings.customNumber2.key}.${customMetadataSettings.customNumber2.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_NUMBER_2,
        );
    }
    if (customMetadataSettings.customNumber3) {
      allCsvColumns[FulfillmentGroupColumnKey.CUSTOM_NUMBER_3] =
        getCustomNumberCsvColumn(
          customMetadataSettings.customNumber3.displayName ??
            `${customMetadataSettings.customNumber3.key}.${customMetadataSettings.customNumber3.namespace}`,
          FulfillmentGroupColumnKey.CUSTOM_NUMBER_3,
        );
    }
  }

  // Add dynamic product custom metadata columns
  if (productCustomMetadataSettings) {
    if (productCustomMetadataSettings.productCustomDate1) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_DATE_1] =
        getProductCustomDateCsvColumn(
          productCustomMetadataSettings.productCustomDate1.displayName ??
            `${productCustomMetadataSettings.productCustomDate1.key}.${productCustomMetadataSettings.productCustomDate1.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_DATE_1,
        );
    }
    if (productCustomMetadataSettings.productCustomDate2) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_DATE_2] =
        getProductCustomDateCsvColumn(
          productCustomMetadataSettings.productCustomDate2.displayName ??
            `${productCustomMetadataSettings.productCustomDate2.key}.${productCustomMetadataSettings.productCustomDate2.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_DATE_2,
        );
    }
    if (productCustomMetadataSettings.productCustomDate3) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_DATE_3] =
        getProductCustomDateCsvColumn(
          productCustomMetadataSettings.productCustomDate3.displayName ??
            `${productCustomMetadataSettings.productCustomDate3.key}.${productCustomMetadataSettings.productCustomDate3.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_DATE_3,
        );
    }
    if (productCustomMetadataSettings.productCustomString1) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_STRING_1] =
        getProductCustomStringCsvColumn(
          productCustomMetadataSettings.productCustomString1.displayName ??
            `${productCustomMetadataSettings.productCustomString1.key}.${productCustomMetadataSettings.productCustomString1.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_STRING_1,
        );
    }
    if (productCustomMetadataSettings.productCustomString2) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_STRING_2] =
        getProductCustomStringCsvColumn(
          productCustomMetadataSettings.productCustomString2.displayName ??
            `${productCustomMetadataSettings.productCustomString2.key}.${productCustomMetadataSettings.productCustomString2.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_STRING_2,
        );
    }
    if (productCustomMetadataSettings.productCustomString3) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_STRING_3] =
        getProductCustomStringCsvColumn(
          productCustomMetadataSettings.productCustomString3.displayName ??
            `${productCustomMetadataSettings.productCustomString3.key}.${productCustomMetadataSettings.productCustomString3.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_STRING_3,
        );
    }
    if (productCustomMetadataSettings.productCustomNumber1) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_NUMBER_1] =
        getProductCustomNumberCsvColumn(
          productCustomMetadataSettings.productCustomNumber1.displayName ??
            `${productCustomMetadataSettings.productCustomNumber1.key}.${productCustomMetadataSettings.productCustomNumber1.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_NUMBER_1,
        );
    }
    if (productCustomMetadataSettings.productCustomNumber2) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_NUMBER_2] =
        getProductCustomNumberCsvColumn(
          productCustomMetadataSettings.productCustomNumber2.displayName ??
            `${productCustomMetadataSettings.productCustomNumber2.key}.${productCustomMetadataSettings.productCustomNumber2.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_NUMBER_2,
        );
    }
    if (productCustomMetadataSettings.productCustomNumber3) {
      allCsvColumns[FulfillmentGroupColumnKey.PRODUCT_CUSTOM_NUMBER_3] =
        getProductCustomNumberCsvColumn(
          productCustomMetadataSettings.productCustomNumber3.displayName ??
            `${productCustomMetadataSettings.productCustomNumber3.key}.${productCustomMetadataSettings.productCustomNumber3.namespace}`,
          FulfillmentGroupColumnKey.PRODUCT_CUSTOM_NUMBER_3,
        );
    }
  }

  // Add dynamic custom attribute columns
  if (customAttributesSettings) {
    if (customAttributesSettings.customAttributeDate1) {
      allCsvColumns.customAttributeDate1 = getCustomDateCsvColumn(
        customAttributesSettings.customAttributeDate1.displayName ??
          customAttributesSettings.customAttributeDate1.key,
        "customAttributeDate1",
      );
    }
    if (customAttributesSettings.customAttributeDate2) {
      allCsvColumns.customAttributeDate2 = getCustomDateCsvColumn(
        customAttributesSettings.customAttributeDate2.displayName ??
          customAttributesSettings.customAttributeDate2.key,
        "customAttributeDate2",
      );
    }
    if (customAttributesSettings.customAttributeDate3) {
      allCsvColumns.customAttributeDate3 = getCustomDateCsvColumn(
        customAttributesSettings.customAttributeDate3.displayName ??
          customAttributesSettings.customAttributeDate3.key,
        "customAttributeDate3",
      );
    }
    if (customAttributesSettings.customAttributeString1) {
      allCsvColumns.customAttributeString1 = getCustomStringCsvColumn(
        customAttributesSettings.customAttributeString1.displayName ??
          customAttributesSettings.customAttributeString1.key,
        "customAttributeString1",
      );
    }
    if (customAttributesSettings.customAttributeString2) {
      allCsvColumns.customAttributeString2 = getCustomStringCsvColumn(
        customAttributesSettings.customAttributeString2.displayName ??
          customAttributesSettings.customAttributeString2.key,
        "customAttributeString2",
      );
    }
    if (customAttributesSettings.customAttributeString3) {
      allCsvColumns.customAttributeString3 = getCustomStringCsvColumn(
        customAttributesSettings.customAttributeString3.displayName ??
          customAttributesSettings.customAttributeString3.key,
        "customAttributeString3",
      );
    }
    if (customAttributesSettings.customAttributeNumber1) {
      allCsvColumns.customAttributeNumber1 = getCustomNumberCsvColumn(
        customAttributesSettings.customAttributeNumber1.displayName ??
          customAttributesSettings.customAttributeNumber1.key,
        "customAttributeNumber1",
      );
    }
    if (customAttributesSettings.customAttributeNumber2) {
      allCsvColumns.customAttributeNumber2 = getCustomNumberCsvColumn(
        customAttributesSettings.customAttributeNumber2.displayName ??
          customAttributesSettings.customAttributeNumber2.key,
        "customAttributeNumber2",
      );
    }
    if (customAttributesSettings.customAttributeNumber3) {
      allCsvColumns.customAttributeNumber3 = getCustomNumberCsvColumn(
        customAttributesSettings.customAttributeNumber3.displayName ??
          customAttributesSettings.customAttributeNumber3.key,
        "customAttributeNumber3",
      );
    }
  }

  // Add dynamic variant custom metadata columns
  if (variantCustomMetadataSettings) {
    if (variantCustomMetadataSettings.variantCustomDate1) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_DATE_1] =
        getVariantCustomDateCsvColumn(
          variantCustomMetadataSettings.variantCustomDate1.displayName ??
            `${variantCustomMetadataSettings.variantCustomDate1.key}.${variantCustomMetadataSettings.variantCustomDate1.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_DATE_1,
        );
    }
    if (variantCustomMetadataSettings.variantCustomDate2) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_DATE_2] =
        getVariantCustomDateCsvColumn(
          variantCustomMetadataSettings.variantCustomDate2.displayName ??
            `${variantCustomMetadataSettings.variantCustomDate2.key}.${variantCustomMetadataSettings.variantCustomDate2.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_DATE_2,
        );
    }
    if (variantCustomMetadataSettings.variantCustomDate3) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_DATE_3] =
        getVariantCustomDateCsvColumn(
          variantCustomMetadataSettings.variantCustomDate3.displayName ??
            `${variantCustomMetadataSettings.variantCustomDate3.key}.${variantCustomMetadataSettings.variantCustomDate3.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_DATE_3,
        );
    }
    if (variantCustomMetadataSettings.variantCustomString1) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_STRING_1] =
        getVariantCustomStringCsvColumn(
          variantCustomMetadataSettings.variantCustomString1.displayName ??
            `${variantCustomMetadataSettings.variantCustomString1.key}.${variantCustomMetadataSettings.variantCustomString1.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_STRING_1,
        );
    }
    if (variantCustomMetadataSettings.variantCustomString2) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_STRING_2] =
        getVariantCustomStringCsvColumn(
          variantCustomMetadataSettings.variantCustomString2.displayName ??
            `${variantCustomMetadataSettings.variantCustomString2.key}.${variantCustomMetadataSettings.variantCustomString2.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_STRING_2,
        );
    }
    if (variantCustomMetadataSettings.variantCustomString3) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_STRING_3] =
        getVariantCustomStringCsvColumn(
          variantCustomMetadataSettings.variantCustomString3.displayName ??
            `${variantCustomMetadataSettings.variantCustomString3.key}.${variantCustomMetadataSettings.variantCustomString3.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_STRING_3,
        );
    }
    if (variantCustomMetadataSettings.variantCustomNumber1) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_NUMBER_1] =
        getVariantCustomNumberCsvColumn(
          variantCustomMetadataSettings.variantCustomNumber1.displayName ??
            `${variantCustomMetadataSettings.variantCustomNumber1.key}.${variantCustomMetadataSettings.variantCustomNumber1.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_NUMBER_1,
        );
    }
    if (variantCustomMetadataSettings.variantCustomNumber2) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_NUMBER_2] =
        getVariantCustomNumberCsvColumn(
          variantCustomMetadataSettings.variantCustomNumber2.displayName ??
            `${variantCustomMetadataSettings.variantCustomNumber2.key}.${variantCustomMetadataSettings.variantCustomNumber2.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_NUMBER_2,
        );
    }
    if (variantCustomMetadataSettings.variantCustomNumber3) {
      allCsvColumns[FulfillmentGroupColumnKey.VARIANT_CUSTOM_NUMBER_3] =
        getVariantCustomNumberCsvColumn(
          variantCustomMetadataSettings.variantCustomNumber3.displayName ??
            `${variantCustomMetadataSettings.variantCustomNumber3.key}.${variantCustomMetadataSettings.variantCustomNumber3.namespace}`,
          FulfillmentGroupColumnKey.VARIANT_CUSTOM_NUMBER_3,
        );
    }
  }

  for (const column of columns) {
    const isDisplayed =
      displayedColumns.find((dc) => dc.key === column.key)?.displayed ?? false;

    if (isDisplayed && column.key in allCsvColumns) {
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      selected_columns.push(allCsvColumns[column.key]);
    }
  }

  return selected_columns;
}
